

const AfterRegisterVerifyEmailPage: React.FC = () => {

    const emailParams = new URLSearchParams(window.location.search);
    const email = emailParams.get("email") || "your email";

    return (
        <section className="after-register-section ">
            <div className="w-layout-blockcontainer container w-container">
                <div className="sttings-content-wrapper padding-tb-20px center">
                    <div className="admin-settings-box-div after-register">
                        <div className="div-block-57">
                            <div className="div-block-56"></div>
                            <div className="description-text">Registracija uspešna</div>
                        </div>
                        <div>
                            <div className="text-block-35">Potvrdi svoju email adresu</div>
                            <div className="description-text">
                                Poslali smo poruku na uneti email. Klikni na link u poruci email-a da aktiviraš nalog.<br />
                            </div>
                        </div>
                        <div className="div-block-58">
                            <div className="description-text">Email adresa</div>
                            <div>{email}</div>
                        </div>
                        <div className="div-block-58 temp">
                            <div className="description-text">Proveri i Spam/Promotions. Link za potvrdu obično važi 30 minuta. Slanje novog emaila može biti ograničeno (npr. jednom u 60 sekundi).</div>
                        </div>
                        <div className="admin-settings-box-body-hr"></div>
                        <div>
                            <div className="description-text">Ako imaš problem, kontaktiraj podršku putem aplikacije ili na email podrške.</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );

};

export default AfterRegisterVerifyEmailPage;